// removed by extract-text-webpack-plugin
module.exports = {"root":"components-PlayButton-__index__root__22-R7","play-icon":"components-PlayButton-__index__play-icon__V0II5"};


//////////////////
// WEBPACK FOOTER
// ./components/PlayButton/index.css
// module id = 795
// module chunks = 0